export class ResourceNotFoundError extends Error {
  constructor(resource: string, id: string | number) {
    super(`${resource} not found (id=${id})`);
    this.name = "ResourceNotFoundError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
